var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24.956,
    height: 32.024,
    viewBox: "0 0 24.956 32.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bell-a,.bell-c,.bell-d{fill:none;stroke:#21212d;stroke-width:2px;}.bell-b{clip-path:url(#bell-a);}.bell-c{stroke-linecap:round;}.bell-c,.bell-d{stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "bell-a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "bell-a",
    width: 24.956,
    height: 32.024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "bell-b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bell-c",
    d: "M3.954,19.7s-.25.512-.555,1.148L.588,26.7c-.231.485,0,.883.518.883H23.569c.515,0,.747-.4.518-.883l-2.81-5.853a6.715,6.715,0,0,1-.555-2.435V11.31a8.384,8.384,0,0,0-16.768,0V19.7Z",
    transform: "translate(0.14 0.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-d",
    d: "M13.764,22.126a3.087,3.087,0,0,1-3.3,3.042,3.09,3.09,0,0,1-3.3-3.042",
    transform: "translate(2.013 6.216)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bell-c",
    d: "M8.007,3.909V2.721a2.222,2.222,0,0,1,4.444,0V3.91",
    transform: "translate(2.25 0.14)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.2fa38e6f.svg";
export { ForwardRef as ReactComponent };